// Shared definitions for quote requests (table public.leads).
// Values must match the CHECK constraints of the leads table.

export const TYPE_DEMANDE_OPTIONS = [
  "Sinistre avec assurance",
  "Accident ou accrochage",
  "Rayure ou bosse",
  "Grêle",
  "Pare-brise",
  "Autre",
] as const;

export const ASSURANCE_OPTIONS = [
  "AXA",
  "Zurich",
  "Allianz",
  "Helvetia",
  "Mobilière",
  "Generali",
  "Baloise",
  "Vaudoise",
  "TCS",
  "Autre",
  "Pas d'assurance",
] as const;

export const LEAD_STATUTS = [
  { value: "nouveau", label: "Nouveau" },
  { value: "rappele", label: "Rappelé" },
  { value: "devis_envoye", label: "Devis envoyé" },
  { value: "gagne", label: "Gagné" },
  { value: "perdu", label: "Perdu" },
] as const;

export type LeadStatut = (typeof LEAD_STATUTS)[number]["value"];

export const LEAD_PHOTOS_BUCKET = "lead-photos";
export const MAX_LEAD_PHOTOS = 5;
export const MAX_LEAD_PHOTO_BYTES = 10 * 1024 * 1024;

const EXT_BY_MIME: Record<string, string> = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/heic": "heic",
  "image/heif": "heif",
  "image/gif": "gif",
  "image/avif": "avif",
};
const ALLOWED_EXT = new Set(["jpg", "jpeg", "png", "webp", "heic", "heif", "gif", "avif"]);

/** Returns an error message, or null when the photo is acceptable. */
export function validateLeadPhoto(file: { name: string; type: string; size: number }): string | null {
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  const isImage = file.type.startsWith("image/") || ALLOWED_EXT.has(ext);
  if (!isImage) return `« ${file.name} » n'est pas une image.`;
  if (file.size > MAX_LEAD_PHOTO_BYTES) return `« ${file.name} » dépasse 10 Mo.`;
  if (!photoExtension(file)) return `Format de « ${file.name} » non accepté (JPG, PNG, WEBP, HEIC).`;
  return null;
}

export function photoExtension(file: { name: string; type: string }): string | null {
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  if (ALLOWED_EXT.has(ext)) return ext;
  return EXT_BY_MIME[file.type] ?? null;
}

export const WHATSAPP_NUMBER = "41766388655";
export const whatsappLink = (text: string) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
